
const Footer: React.FC = () => {
    return (
        <div style={{ height: "50px" }}>

        </div>
    )
}

export default Footer;